import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import toast from "../helpers/toast";
import Httpconfig from "../helpers/HttpconfigAdmin";
import Constant from "../../constants";
import { MDBDataTable } from "mdbreact";
import { Link } from "react-router-dom";

export default class Viewhealthmedicine extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countries_data: "",
      datatable: {
        columns: [
          {
            label: "Medicine ID",
            field: "id",
            sort: "asc",
            width: 150,
          },
          {
            label: "Medicine Name",
            field: "name",
            sort: "asc",
            width: 270,
          },
          {
            label: "Actions",
            field: "actions",
            sort: "asc",
            width: 10,
          },
        ],
        rows: [],
      },
    };
  }

  // To get detais after first render
  componentDidMount = () => {
    this.healthmedicinedata();
  };

  //  For getting medicin data
  healthmedicinedata() {
    Httpconfig.httptokenget(Constant.siteurl + "api/Healthosmedicine/fetchAll")
      .then((response) => {
        this.setState({
          languages_data: response.data,
        });
        let assignvalues = [];
        this.items = response.data.map((item, key) =>
          assignvalues.push({
            id: item.medicineid,
            name: item.medicinename,
            actions: (
              <div>
                <span>
                  <Link
                    to={"/admin/Createhealthmedicinedata/" + item.id}
                    className="fa fa-edit point-cursor"
                    title={"Update " + item.medicinename}
                  ></Link>
                </span>{" "}
                &nbsp;
                <span>
                  <i
                    onClick={() =>
                      this.deletehealthmedicine(item.id, item.medicinename)
                    }
                    className="fa fa-trash point-cursor"
                    title={"Delete " + item.medicinename}
                  ></i>
                </span>{" "}
                &nbsp;
              </div>
            ),
          })
        );

        let healthmedicineState = Object.assign({}, this.state);
        healthmedicineState.datatable.rows = assignvalues;
        this.setState(healthmedicineState);
      })
      .catch((error) => {});
  }

  //delete controller
  deletehealthmedicine(userId, name) {
    var isConfirm = window.confirm("Are you sure to delete " + name + "?");
    if (isConfirm) {
      Httpconfig.httptokendelete(
        Constant.siteurl + "api/Healthosmedicine/" + userId
      )
        .then((response) => {
          toast.success("Successfully Deleted Health medicine");
          setTimeout(() => window.location.reload(), 2000);
        })
        .catch((error) => {});
    }
  }
  render() {
    const { datatable } = this.state;
    return (
      <section id="main_dashboard">
        <div className="container" id="main_front">
          <div className="row">
            <div className="col-md-12">
              <div className="dash-section">
                <div className="section-header">
                  <ol className="breadcrumb">
                    <li className="active">
                      <Link to="/admin"> Dashboard</Link> &gt; Healthosmedicine
                    </li>
                  </ol>
                </div>
              </div>

              <section id="CMS_tab">
                <div className="CMS_content">
                  <div className="container">
                    <div className="row">
                      <div className="tab-header">
                        <h3>Healthosmedicine</h3>
                      </div>
                      <div id="reg_form">
                        <form>
                          <div className="row">
                            <div className="form-group col-md-12">
                              <Link
                                to="/admin/Createhealthmedicinedata"
                                className="btn  btn-primary fright"
                              >
                                Create Healthosmedicine
                              </Link>
                            </div>
                          </div>
                        </form>
                        {datatable.rows.length === 0 ? (
                          <p>Loading............</p>
                        ) : (
                          <MDBDataTable
                            striped
                            responsive
                            bordered
                            small
                            data={datatable}
                          />
                        )}
                        <div className="row">
                          <div className="col-md-12">
                            <div
                              className="update_btn"
                              style={{ textAlign: "right" }}
                            ></div>
                          </div>
                        </div>
                        <ToastContainer />
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
